// extracted by mini-css-extract-plugin
export var bio = "introDivs-module--bio--oORAw";
export var introDiv = "introDivs-module--introDiv--n-Kgx";
export var introPhoto = "introDivs-module--introPhoto--mzyb5";
export var introText = "introDivs-module--introText--anYGZ";
export var photo = "introDivs-module--photo--jxGuC";
export var photoWrapper = "introDivs-module--photoWrapper--kmirV";
export var sherzod = "introDivs-module--sherzod--YSMQv";
export var title = "introDivs-module--title--oXjug";